// de-front/de-order-admin/src/pages/supplier-sales/list/types.ts
import { IOrderPlus } from "../../../models/Order"

export type Filters = {
  type?: string
  businessId?: string | null
  paymentTermCondition?: string | null
  salesCode?: string
  createdAt?: [string | null, string | null]
  orderType?: string | null
  orderStatus?: string | null
  orderedUserFirstName?: string
  receiverPartnerRefCodeBusinessName?: string
  receiverBusinessRegNumber?: string
  receiverBusinessRefCodeProfileName?: string
  receiverBranchName?: string
  receiverStaffFirstNamePhone?: string
  deliveryDate?: [string | null, string | null]
  deliveryNoteStatus?: string | null
  deliveryStaffFirstNameEmail?: string
  deliveryNoteDeliveryDate?: [string | null, string | null]
  totalAmount: [number | string | null, number | string | null]
  paidAmount: [number | string | null, number | string | null]
  amountToPay: [number | string | null, number | string | null]
  paymentStatus?: string | null
  paymentTermDescription?: string
  purchaseCode?: string
  respondedDate?: [string | null, string | null]
  purchaseType?: string | null
  orderedUserFirstNamePhone?: string
}

export const INITIAL_FILTERS: Filters = {
  type: "SALES",
  businessId: null,
  paymentTermCondition: null,
  salesCode: "",
  createdAt: [null, null],
  orderType: null,
  orderStatus: null,
  orderedUserFirstName: "",
  receiverPartnerRefCodeBusinessName: "",
  receiverBusinessRegNumber: "",
  receiverBusinessRefCodeProfileName: "",
  receiverBranchName: "",
  receiverStaffFirstNamePhone: "",
  deliveryDate: [null, null],
  deliveryNoteStatus: null,
  deliveryStaffFirstNameEmail: "",
  deliveryNoteDeliveryDate: [null, null],
  totalAmount: [null, null],
  paidAmount: [null, null],
  amountToPay: [null, null],
  paymentStatus: null,
  paymentTermDescription: "",
  purchaseCode: "",
  respondedDate: [null, null],
  purchaseType: null,
  orderedUserFirstNamePhone: "",
}

export type ConsignmentFilter = "ALL" | "REGULAR" | "CONSIGNMENT" | "VMI_CRON"

export type RowActionKey =
  | "edit"
  | "detail"
  | "cancel"
  | "reviewed"
  | "confirm"
  | "reject"
  | "backorder"

export type ActionState =
  | { kind: "none" }
  | { kind: "cancel"; record: IOrderPlus }
  | { kind: "reviewed"; record: IOrderPlus }
  | { kind: "confirm"; record: IOrderPlus; constant: "confirm" }
  | { kind: "reject"; record: IOrderPlus; constant: "reject" }

export type SupplierSalesListProps = {
  setChecked: (next: any) => void
  actions: any[]
  checked: any[]
  setActions: (next: any[]) => void
  /** Primary action of the empty state: open the «Шинэ захиалга» screen. */
  onCreate?: () => void
  /** «split» (Хэсэгчлэн хүргэх tab) reuses this same table: split API, detail action only. */
  mode?: "sales" | "split"
  /** Type chips owned by the page (shared header row with the tabs); omitted → local state. */
  consignmentFilter?: ConsignmentFilter
  setConsignmentFilter?: (v: ConsignmentFilter) => void
}

export type SupplierSalesListRef = {
  getFilters: () => Filters
  getOrder: () => [string, "ASC" | "DESC"]
  reload: () => void
}
